import Loadable from "app/components/Loadable";
import React, { lazy } from "react";
const MySchool = Loadable(lazy(() => import("./List")));
const UploadCSV = Loadable(lazy(() => import("./UploadCSV")));
const ApproveSchhol = Loadable(lazy(() => import("./ApproveSchhol")));

const myschoolRoutes = [
    { path: "/my-region/list", element: <MySchool /> },
    { path: "/my-region/manage-schools", element: <UploadCSV /> },
    { path: "/my-region/manage-schools/school", element: <ApproveSchhol /> },

];

export default myschoolRoutes;  